import { DataArray, DataDisplay, formatSchoolYear, Grid, useElementBreakpoints } from "@compass/core";
import { DataCenterFile, DataCenterFileTask, LkDataCenterFileTaskContentId } from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const DataCenterFileInfoTask = (props: { dataCenterFile: DataCenterFile }) => {
  const { breakpointsRef, fullFieldBreakpoints } = useElementBreakpoints();
  const [infoTask, setInfoTask] = useState<DataCenterFileTask>();

  useEffect(() => {
    if (props.dataCenterFile.infoTaskId && props.dataCenterFile.infoTaskId > 0) {
      ApiService.dataCenterFileTasks
        .get(props.dataCenterFile.infoTaskId, undefined)
        .then((response) => setInfoTask(response));
    }
  }, [props.dataCenterFile.infoTaskId]);

  const showContentUpdates =
    infoTask?.contents &&
    infoTask?.contents.filter((x) => x.id === Number(LkDataCenterFileTaskContentId.Updates)).length > 0
      ? true
      : false;

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={fullFieldBreakpoints}>
        <DataDisplay label="Upload User">{props.dataCenterFile.createdByClientUser}</DataDisplay>
      </Grid>

      <Grid item xs={fullFieldBreakpoints}>
        <DataDisplay label="Data Types">
          <DataArray value={infoTask?.dataTypes?.map((x) => x.name!)} />
        </DataDisplay>
      </Grid>

      <Grid item xs={fullFieldBreakpoints}>
        <DataDisplay label="Contents">
          <DataArray value={infoTask?.contents?.map((x) => x.name!)} />
        </DataDisplay>
      </Grid>

      {showContentUpdates && (
        <Grid item xs={fullFieldBreakpoints}>
          <DataDisplay label="Content Updates">
            <DataArray value={infoTask?.contentUpdates?.map((x) => x.name!)} />
          </DataDisplay>
        </Grid>
      )}

      <Grid item xs={fullFieldBreakpoints}>
        <DataDisplay label="School Years">
          <DataArray value={infoTask?.schoolYears?.map((x) => formatSchoolYear(x.schoolYear))} />
        </DataDisplay>
      </Grid>

      <Grid item xs={fullFieldBreakpoints}>
        <DataDisplay label="note" type="textarea">
          {props.dataCenterFile.note}
        </DataDisplay>
      </Grid>
    </Grid>
  );
};
